/* eslint-disable no-unused-vars */
import { ConfigApi } from "../api/base/ConfigApi";
import ApiStore from "./AppStore/ApiStore";
import MembersStore from "./AppStore/MembersStore";
import ApplicationStore from "./AppStore/ApplicationStore";

class RootStore {
  applicationStore: ApplicationStore;
  membersStore: MembersStore;
  constructor(configApi: ConfigApi, isFinCen: boolean = false) {
    const api = new ApiStore(configApi);

    this.applicationStore = new ApplicationStore(api, isFinCen);
    this.membersStore = new MembersStore(api);
  }

}

export default RootStore;